import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useCompletedTaskList } from '../../services';
import { fireAnalyticsOnChecklistItemCompleted } from '../../utils/analytics';

export const useMarkAsCompleteAndExpand = () => {
	const [completedTaskList, { nextMarkAsCompletedTask, nextAutoExpand }] = useCompletedTaskList();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (taskId: string) => {
		const taskAlreadyCompleted = completedTaskList.includes(taskId);

		if (taskAlreadyCompleted) {
			return;
		}
		nextMarkAsCompletedTask(taskId);
		fireAnalyticsOnChecklistItemCompleted(createAnalyticsEvent, taskId);
		nextAutoExpand();
	};
};
